import logo from "../assets/images/logo.png";
import {
  FaGlobe,
  FaEnvelope,
  FaPhoneAlt,
  FaMapPin,
  FaTelegram,
  FaWhatsapp,
  FaViber,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "../i18n";

export const Navbar = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); // Change language
  };

  return (
    <>
      <div className="top-bar">
        <div className="container">
          <div className="row g-3 d-flex align-items-center">
            <div className="col-md-6">
              <ul className="list-unstyled mb-0 d-flex">
                <li className="me-3">
                  <FaEnvelope className="text-white" />{" "}
                  <a href="mailto:paju@inbox.lv" alt="email">
                    paju@inbox.lv
                  </a>
                </li>
                <li className="me-3">
                  <FaPhoneAlt className="text-white" />{" "}
                  <a href="tel:+371 29825460" alt="phone">
                    +371 29825460
                  </a>
                </li>
                <li>
                  <FaMapPin className="text-white" />{" "}
                  <a href="/" alt="phone">
                    Riga,Latvia
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-center justify-content-md-end">
                <a
                  href="https://t.me/+37129825460"
                  className="me-3 fs-4"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaTelegram />
                </a>
                <a
                  href="https://wa.me/37129825460"
                  className="me-3 fs-4"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaWhatsapp />
                </a>
                <a
                  href="viber://chat?number=%2B+37129825460"
                  className="fs-4"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaViber />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <a className="navbar-brand" href="/">
            <img src={logo} width="100px" alt="logo" />
          </a>
          {/* <button
            className="navbar-toggler bg-white"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button> */}
          {/* <div className="collapse navbar-collapse" id="navbarSupportedContent"> */}
          {/* <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link" href="/">
                  {t("home")}
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#about">
                  {t("about")}
                </a>
              </li>
            </ul> */}

          {/* </div> */}
          <ul className="list-unstyled d-flex ms-auto mt-2">
            <div className="dropdown">
              <a
                className="dropdown-toggle text-white text-decoration-none"
                href="/"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FaGlobe className="text-white" /> {t("Select Language")}
              </a>
              <ul className="dropdown-menu">
                <li>
                  <a
                    className="dropdown-item"
                    onClick={() => changeLanguage("en")}
                    href="/"
                  >
                    English
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    onClick={() => changeLanguage("lv")}
                    href="/"
                  >
                    Latviešu
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    onClick={() => changeLanguage("ru")}
                    href="/"
                  >
                    Русский
                  </a>
                </li>
              </ul>
            </div>
          </ul>
        </div>
      </nav>
    </>
  );
};
